/**
 * Mã nguồn dữ liệu — suy từ tên hiển thị, và **không đổi được sau khi dựng kho** (port `ma-nguon.ts` native).
 *
 * Mã đi thẳng vào TÊN cơ sở dữ liệu của bản sao: vừa khó nhất (phải hợp lệ với máy chủ) vừa không sửa lại được. Suy từ
 * tên thì người dùng chỉ phải trả lời một câu họ biết: "nguồn này tên gì?"
 *
 * Khác native: mã hiện CHỈ ĐỌC cạnh ô tên (ADR-UI-0014) — native cho gõ đè mã. Luật vẫn của native (chữ thường,
 * `^[a-z][a-z0-9_]*$`, tối đa 48, khử trùng bằng hậu tố `_2`), không phải `lib/ma-tu-sinh.ts` (chữ HOA): máy chủ
 * `tro-ly-ai` chỉ nhận chữ thường.
 */

export const DAI_TOI_DA = 48;
const THAY = /[^a-z0-9]+/g;

/** Tên tiếng Việt → mã máy chủ nhận được. */
export function slugMaNguon(ten: string): string {
  const s = (ten || '')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase()
    .replace(THAY, '_')
    .replace(/^_+|_+$/g, '');
  if (!s) return '';
  // Máy chủ đòi ký tự đầu là CHỮ. Tên bắt đầu bằng số là chuyện thường ("2026 báo cáo"), nên thêm tiền tố.
  const coChuDau = /^[a-z]/.test(s) ? s : `n_${s}`;
  return coChuDau.slice(0, DAI_TOI_DA).replace(/_+$/g, '');
}

/** Mã chưa ai dùng, suy từ tên. Rỗng nếu tên không sinh ra được mã nào. */
export function maNguonDuyNhat(ten: string, daCo: readonly string[]): string {
  const goc = slugMaNguon(ten);
  if (!goc) return '';
  const dung = new Set(daCo);
  if (!dung.has(goc)) return goc;
  for (let i = 2; i < 100; i += 1) {
    const hau = `_${i}`;
    // Cắt phần GỐC để chừa chỗ cho hậu tố, không cắt sau khi ghép — ghép rồi cắt sẽ xoá mất chính hậu tố vừa thêm khi
    // tên đã dài 48 ký tự, và vòng lặp trả về cùng một chuỗi mãi mãi.
    const than = goc.slice(0, DAI_TOI_DA - hau.length).replace(/_+$/g, '');
    const thu = `${than}${hau}`;
    if (!dung.has(thu)) return thu;
  }
  return '';
}
